import { render, staticRenderFns } from "./dangerousGoodsListSafetyDataSheet.vue?vue&type=template&id=3ef26358"
import script from "./dangerousGoodsListSafetyDataSheet.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListSafetyDataSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports